module.exports = __webpack_public_path__ + "static/Logo-Fin-f9204d83b8a505ab3b915389a709cf1a.png";